module.exports = __webpack_public_path__ + "assets/img/e2.05cde7b8.jpg";